import { render, staticRenderFns } from "./FabledModal.vue?vue&type=template&id=36e02320&scoped=true&"
import script from "./FabledModal.vue?vue&type=script&lang=js&"
export * from "./FabledModal.vue?vue&type=script&lang=js&"
import style0 from "./FabledModal.vue?vue&type=style&index=0&id=36e02320&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36e02320",
  null
  
)

export default component.exports